interface GetGoogleAuthTokensResult {
    idToken: string | null;
    accessToken: string | null;
}

/**
 * Retrieves Google auth tokens from localStorage
 * */
export function getGoogleAuthTokens(): GetGoogleAuthTokensResult {
    const idToken = localStorage.getItem("google_auth_id_token");
    const accessToken = localStorage.getItem("google_auth_access_token");

    if (idToken) {
        localStorage.removeItem("google_auth_id_token");
    }
    if (accessToken) {
        localStorage.removeItem("google_auth_access_token");
    }

    return { idToken, accessToken };
}

